import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { styles } from './Workbench.styles';
import styled from 'styled-components';
import ClaimHeader from '../components/workbench/ClaimHeader';
import RecommendationCards from '../components/workbench/RecommendationCards';
import AIIntelligenceCards from '../components/workbench/AIIntelligenceCards';
import { fetchWorkbenchDataFromAPI } from '../services/workbenchDataService';
import MetaClaimsAI from '../components/common/MetaClaimsAI';
import { getUserData } from '../utils/authUtils';
const Sidebar = styled.div`
  width: ${props => props.isOpen ? `${props.width}px` : '0px'};
  min-width: ${props => props.isOpen ? '300px' : '0px'};
  max-width: ${props => props.isOpen ? '600px' : '0px'};
  flex-shrink: 0;
  padding-left: ${props => props.isOpen ? '0.75rem' : '0'};
  padding-right: ${props => props.isOpen ? '1rem' : '0'};
  padding-top: ${props => props.isOpen ? '1rem' : '0'};
  overflow: ${props => props.isOpen ? 'visible' : 'hidden'};
  transition: width 0.3s ease-in-out, min-width 0.3s ease-in-out, padding 0.3s ease-in-out;
  position: sticky;
  top: 0;
  align-self: flex-start;
  max-height: 100vh;
`;

const FloatingActionButton = styled.button`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: ${props => props.show ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 1000;
  padding: 0;
  
  & > img {
    width: 100%;
    height: 100%;
  }
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;
const Workbench = () => {
  const navigate = useNavigate();
  const { manualTaskId } = useParams();
  const [workbenchData, setWorkbenchData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sidebarWidth, setSidebarWidth] = useState(400);
  const [isAISidebarOpen, setIsAISidebarOpen] = useState(true);
  const [associatedEntityData, setAssociatedEntityData] = useState({});
  const [isResizing, setIsResizing] = useState(false);
  const location = useLocation();
  const basePath = process.env.PUBLIC_URL || '';

   const entityNavigationConfig = [
    {
      entityCode: 'PERSON_PROFILE',
      tabKey: 'PERSON_PROFILE',
      buttonLabel: 'Profile',
      icon: `${basePath}/assets/images/workbench/Profile.jpg`
    },
    {
      entityCode: 'CLAIM_DETAILS',
      tabKey: 'CLAIM_DETAILS',  // Maps to tab in EntityTabsContainer
      buttonLabel: 'Claim',
      icon: `${basePath}/assets/images/workbench/Claim.jpg`
    },
    {
      entityCode: 'POLICY_DETAILS',
      tabKey: 'policy_details',  // Maps to tab in EntityTabsContainer
      buttonLabel: 'Policy',
      icon: `${basePath}/assets/images/workbench/Policy.jpg`
    },
    {
      entityCode: 'DISCHARGE_SUMMARY',
      tabKey: 'DISCHARGE_SUMMARY',
      buttonLabel: 'Discharge',
      icon: `${basePath}/assets/images/workbench/Discharge.jpg`
    },
    {
      entityCode: 'CLAIM_HISTORY',
      tabKey: 'CLAIM_HISTORY',
      buttonLabel: 'History',
      icon: `${basePath}/assets/images/workbench/History.jpg`
    }
  ];

  
  // From navigation state
  const workflow_code = location.state?.workflow_code;
  const workflow_instance_id = location.state?.workflow_instance_id;
  const slaPercentage = location.state?.slaPercentage;
  // console.log('Manual Task ID:', manualTaskId);
  // console.log('Workflow Code:', workflow_code);
  // console.log('Workflow Instance ID:', workflow_instance_id);
  const dummyRecommendationData = [
    {
      "pathId": "policy_deduction",
      "rank": 1,
      "primary": true,
      "recommendedBadgeText": "AI Recommended",
      "title": "Refer to Audit",
      "description": "Reject non-admissible items as per Rule R-9.0.",
      "payableAmountText": "IDR 104,500",
      "payableAmount": 104500,
      "statusText": null,
      "statusSeverity": "info",
      "ctaText": "Submit",
      "ctaAction": "SUBMIT_DECISION_PATH",
      "markdown": "Payable amount **IDR 104,500**",
      "data": {
        "payable_amount": 104500,
        "audit_saving_amount": 23300,
        "audit_saving_percent": 17,
        "rule_refs": "R-9.0",
        "adjustments_text": "Reject non-admissible items"
      }
    },
    {
      "pathId": "partial_waiver",
      "rank": 2,
      "primary": false,
      "recommendedBadgeText": null,
      "title": "Partial Waiver",
      "description": "Allow LOS variance (+IDR12K), reject kits.",
      "payableAmountText": "IDR 116,500",
      "payableAmount": 116500,
      "statusText": null,
      "statusSeverity": "neutral",
      "ctaText": "Submit",
      "ctaAction": "SUBMIT_DECISION_PATH",
      "markdown": "Payable amount **IDR 116,500**",
      "data": {
        "payable_amount": 116500,
        "audit_saving_amount": null,
        "audit_saving_percent": null,
        "rule_refs": null,
        "adjustments_text": "Allow LOS variance; reject kits"
      }
    },
    {
      "pathId": "full_audit_pending",
      "rank": 3,
      "primary": false,
      "recommendedBadgeText": null,
      "title": "Full Audit Pending",
      "description": "Escalate for on-site ICU verification.",
      "payableAmountText": "IDR 0 (On Hold)",
      "payableAmount": 0,
      "statusText": "On Hold",
      "statusSeverity": "warning",
      "ctaText": "Submit",
      "ctaAction": "SUBMIT_DECISION_PATH",
      "markdown": "Payable amount **IDR 0** (On Hold)",
      "data": {
        "payable_amount": 0,
        "on_hold": true,
        "hold_reason": "Requires on-site ICU verification",
        "audit_saving_amount": null,
        "audit_saving_percent": null,
        "rule_refs": null,
        "adjustments_text": "Escalate to audit"
      }
    }
  ];

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isResizing) return;
      
      const wrapper = document.querySelector('[data-container="workbench-main"]');
      if (!wrapper) return;
      
      const wrapperRect = wrapper.getBoundingClientRect();
      const newWidth = wrapperRect.right - e.clientX - 8;
      
      if (newWidth >= 300 && newWidth <= 600) {
        setSidebarWidth(newWidth);
      }
    };
    
    const handleMouseUp = () => {
      setIsResizing(false);
    };
    
    if (isResizing) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    }
    
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
  }, [isResizing]);

  useEffect(() => {
    const loadWorkbenchData = async () => {
      if (!manualTaskId) {
        setError('Manual Task ID is required');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const data = await fetchWorkbenchDataFromAPI(manualTaskId, workflow_code, workflow_instance_id);
        setWorkbenchData(data);
        // console.log('Workbench data:', data);
        // Extract and store associated entity data for navigation
        if (data?.manualTask?.in_detail_entities) {
          const entityMap = {};
          data.manualTask.in_detail_entities.forEach(entity => {
            if (entity.entity_cd && data.entityConfigs[entity.entity_cd]) {
              entityMap[entity.entity_cd] = {
                entity_cd: entity.entity_cd,
                entity_id: entity.entity_id,
                entity_config_data: data.entityConfigs[entity.entity_cd]
              };
            }
          });
          setAssociatedEntityData(entityMap);
        }
      } catch (error) {
        console.error('Error loading workbench data:', error);
        setError('Failed to load workbench data. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    loadWorkbenchData();
  }, [manualTaskId, workflow_code, workflow_instance_id]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <img
          src={`${basePath}/images/spinning-dots.svg`}
          alt="loading..."
          style={{ width: '200px', height: '200px' }}
        />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2 style={{ color: '#ef4444' }}>Error</h2>
        <p>{error}</p>
        <button 
          onClick={() => navigate('/listing')}
          style={{
            marginTop: '1rem',
            padding: '0.5rem 1rem',
            background: '#00A1FF',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          Go Back
        </button>
      </div>
    );
  }

  if (!workbenchData) {
    return null;
  } else {

    const handleResizeStart = () => {
      setIsResizing(true);
    };

    const resizeHandleStyle = {
      width: '8px',
      cursor: 'col-resize',
      background: 'transparent',
      position: 'relative',
      flexShrink: 0,
      transition: 'background 0.2s',
      height: 'calc(100vh - 100px)',
    };

    const resizeHandleBeforeStyle = {
      content: '',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '2px',
      height: '40px',
      background: '#d1d5db',
      borderRadius: '2px',
    };

    return (
      // ONly show if workbenchData is present
      <div style={{...styles.container, position: 'relative'}}>
        {/* Thin Actions Bar on the Right */}
        <div style={styles.actionsBar}>
          {/* Progress Circle */}
          <div style={styles.progressContainer}>
            <div style={styles.progressInner}>
              {slaPercentage !== null && slaPercentage !== undefined ? `${slaPercentage}%` : '0%'}
            </div>
            <div style={{
              ...styles.progressCircle,
              background: `conic-gradient(#00A1FF 0% ${slaPercentage || 0}%, #e3f5f5 ${slaPercentage || 0}% 100%)`
            }}>

            </div>
            <button style={styles.viewAllTasksButton} onClick={() => navigate('/listing')}>
              VIEW ALL<br />TASKS
            </button>
          </div>

          {/* Divider */}
          <div style={styles.divider}></div>

          {/* Documents Button */}
          {/* <div style={styles.actionButton}>
            <div style={styles.actionIcon}>
              <img src={`${basePath}/assets/images/workbench/Document.jpg`} alt="Documents" style={{ width: '30px', height: '30px' }} />

            </div>
            <span style={styles.actionLabel}>Documents</span>
          </div> */}

          {/* Dynamic Entity Navigation Buttons */}
          {entityNavigationConfig.map((config) => {
            const entityData = associatedEntityData[config.entityCode];
            // console.log('Entity data for', config.entityCode, ':', entityData, associatedEntityData);
            const hasData = !!entityData;
            
            return (
              <div 
                key={config.entityCode}
                style={{
                  ...styles.actionButton,
                  cursor: hasData ? 'pointer' : 'default',
                  opacity: hasData ? 1 : 0.5
                }} 
                onClick={() => {
                  if (!hasData) return;
                  
                  const claimId = workbenchData?.sessionState?.caseId;
                  const manualTaskId = workbenchData?.manualTask?.id;
                  
                  if (claimId) {
                    navigate(`/workbench-claim-details/${claimId}/${manualTaskId}`, {
                      state: {
                        workbenchData,
                        associatedEntityData,  // Pass all entity data
                        activeTabKey: config.tabKey,  // Specify which tab to open
                        entityCode: config.entityCode,
                        manualTaskId,
                        slaPercentage,
                      }
                    });
                  }
                }}
              >
                <div style={styles.actionIcon}>
                  <img src={config.icon} alt={config.buttonLabel} style={{ width: '30px', height: '30px' }} />
                </div>
                <span style={styles.actionLabel}>{config.buttonLabel}</span>
              </div>
            );
          })}

        </div>

        {/* Content Wrapper for Main + Sidebar */}
        <div style={{display: 'flex', flex: 1, position: 'relative'}} data-container="workbench-main">
          {/* Main Content Area */}
          <div style={{...styles.mainContent, flex: 1, minWidth: '400px', overflow: 'auto', paddingRight: '0.75rem'}}>
          {/* Claim Header */}
          <ClaimHeader
            dataPoints={workbenchData?.dataPoints}
            sessionState={workbenchData?.sessionState}
            summary={workbenchData?.aiRecommendations?.summary || ""}
          />
          {/* AI Recommended Decision Paths */}
          {workbenchData?.aiRecommendations?.recommendations ?(<>
            <RecommendationCards
              recommendations={workbenchData?.aiRecommendations?.recommendations}
            />
          </>):(<>
          {/* This is with DUmmy Data */}
            <RecommendationCards
              recommendations={dummyRecommendationData}
            />
          </>)}
          {/* AI Claims Intelligence */}
          {loading ? (
            <div style={{ padding: '2rem', textAlign: 'center' }}>Loading AI Intelligence Cards...</div>
          ) : workbenchData ? (
            <AIIntelligenceCards
              cards={workbenchData.aiCards}
              title={workbenchData.aiIntelligencePanelConfig?.title}
              sub_title={workbenchData.aiIntelligencePanelConfig?.sub_title}
            />
          ) : null}
          </div>

          {/* Resize Handle */}
          <div 
            style={resizeHandleStyle}
            onMouseDown={handleResizeStart}
            onMouseEnter={(e) => e.currentTarget.style.background = '#e5e7eb'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
          >
            <div style={resizeHandleBeforeStyle}></div>
          </div>
          {/* AI Panel Sidebar */}
          <Sidebar width={sidebarWidth} isOpen={isAISidebarOpen}>
            <MetaClaimsAI
              userName={getUserData()?.firstname || 'User'}
              userEmail={getUserData()?.username || ''}
              userId={workbenchData?.pipelineInstance?.user_id}
              sessionId={workbenchData?.pipelineInstance?.pipeline_id}
              plannerCd={workbenchData?.co_pilot_agent?.planner_cd}
              initialMessage={workbenchData?.manualTask?.co_pilot_summary}
              initialHiddenQuery={
                workbenchData?.manualTask?.co_pilot_summary
                  ? null
                  : "Provide a detailed executive summary about all agents.\nUse well-structured Markdown and include:\n\n- A short overview paragraph (what each agent response is)"
              }
              contextMessage="Ask me to fetch data, explain rules, or help you start working on a claim."
              showProgress={true}
              progressValue="55%"
              progressLabel="Progress"
              suggestions={[
                "How is my workload compared to yesterday?",
                "Which claims have the highest financial impact?",
                "Show me high-risk cases in my queue.",
                "What is causing delays in my cases?"
              ]}
              onClose={() => setIsAISidebarOpen(false)}
            />
          </Sidebar>

          <FloatingActionButton 
            show={!isAISidebarOpen} 
            onClick={() => setIsAISidebarOpen(true)}
            title="Open MetaClaims AI"
          >
            <img src={`${basePath}/images/AI_Bubble.png`} alt="AI" />
          </FloatingActionButton>
        </div>
      </div>

    );
  }

};

export default Workbench;
